<template>
    <div class="formWrap">
        <div class="formWrap_container verify_container">
            <a class="formWrap_logo" :href="$page.props.home_url ?? '/'">
                <IconLogo />
            </a>
            <h1>VERIFY YOUR EMAIL</h1>
            <p>We`ve sent a verification link to <strong>{{ user.email }}</strong>. Before proceeding, please check your email.</p>

            <div class="formWrap_form_bottom loginWrap_form_bottom">
                <BaseButton color="blue" @click="handleAlreadyVerified">
                    Already verified
                </BaseButton>

                <p class="notice">
                    Didn't get a code?
                    <button type="button" @click="resendVerificationCode">Resend</button>
                </p>
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
import { router } from '@inertiajs/vue2';
import BaseButton from '@/components/base/BaseButton.vue';
import IconLogo from '@/components/icons/IconLogo.vue';
import route from 'ziggy-js';

defineProps<{
    user: {
        email: string;
    };
}>();

function handleAlreadyVerified() {
    router.visit(route('organization.create'));
}

function resendVerificationCode() {
    router.post(route('verification.resend'));
}
</script>

<style lang="scss">
.formWrap {
    padding: 32px;

    @media screen and (max-width: 767px) {
        padding: 16px;
    }

    &_container {
        max-width: 557px;
        margin: 0 auto;
        @media screen and (max-width: 1540px) {
            max-width: 424px;
        }
    }
    &_logo {
        width: 225px;
        margin: 0 auto;
        display: block;
        text-decoration: none;
        svg {
            width: 100%;
            height: auto;
        }

        @media screen and (max-width: 1540px) {
            width: 170px;
        }
    }

    h1 {
        text-align: center;
        padding: 28px 0 36px;
        @media screen and (max-width: 1540px) {
            padding: 23px 0 27px;
        }
    }

    &_form_bottom {
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;

        .notice {
            padding-top: 20px;
        }
    }
}

.verify_container {
    h1 {
        padding-bottom: 24px;
    }
    p {
        margin: 0;
        text-align: center;
        padding-bottom: 40px;
        font-family: "ITC Avant Garde Gothic Std",serif;
        font-size: 16px;
        font-style: normal;
        font-weight: 300;
        line-height: 175%;
        strong {
            font-weight: 600;
        }
    }
}
</style>
